import { SelectOption } from "types";

export const getSelectOptions = <T = string>(
  options: Array<T>,
  propAsLabel?: keyof T,
  propAsValue?: keyof T
): SelectOption[] => {
  const selectOptions = options.map((option) => ({
    label:
      propAsLabel && option && typeof option === "object"
        ? option[propAsLabel]
        : option,
    value:
      propAsValue && option && typeof option === "object"
        ? option[propAsValue]
        : option,
  }));

  return selectOptions as SelectOption[];
};
